export const formatDate = (a: Date | null | string |undefined) =>
  a === null || a === void 0
    ? ''
    : a.toLocaleString('en-US', { dateStyle: 'medium' });

export const formatDateUTC = (date?: string | number | Date | null): string => {
  if (!date) return 'n/a';

  const d = date instanceof Date ? date : new Date(date);

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(d);
};


export const parseDate = (a: string | number | null) =>
  a === null ? null : new Date(a);
